import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import Search from "../../components/Search";
import _ from "lodash";

import Index from "../Index";
import { fetchAllStarterCampaigns } from "../../actions/index";
import AdminStarterCampaignsIndexTourSteps from "../tours/AdminStarterCampaignsIndexTourSteps";

export class AdminStarterCampaignsIndex extends Index {
  static propTypes = {
    fetchAllStarterCampaigns: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    campaigns: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchAllStarterCampaigns(
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/starter_campaigns${this.serialize(newQueries)}`);
  }

  renderCampaigns() {
    if (!this.props.campaigns.data) {
      return (
        <tr>
          <td colSpan={13}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              />
            </div>
          </td>
        </tr>
      );
    } else if (this.props.campaigns.data.length == 0) {
      return (
        <tr>
          <td colSpan={13}>
            <div className="well well-lg text-center">
              You have no active starter workflows.&nbsp;
              <Link
                to={`/admin/starter_campaigns/new`}
                className=""
              >
                Click here to create one.
              </Link>
            </div>
          </td>
        </tr>
      );
    }

    return this.props.campaigns.data.map(campaign => {
      let statusLabel =
        campaign.status == "Active" ? "label-success" : "label-default";
      return (
        <tr key={campaign.id}>
          <td>
            <Link
              to={`/campaigns/${ campaign.id }`}
            >
              <strong>{campaign.name}</strong>
            </Link>
          </td>
          <td className="">{campaign.category}</td>
          <td className="">{campaign.author}</td>
          <td className="">
            {_.truncate(campaign.description, { length: 40 })}
          </td>
          <td className="text-center">
            <span className={`label ${statusLabel}`}>{campaign.status}</span>
          </td>
          <td className="text-right">{campaign.versions[0].steps ? campaign.versions[0].steps.length : campaign.steps_count }</td>
          <td className="text-right">
            <Link
              to={`/campaigns/${ campaign.id }`}
              className="btn btn-sm btn-default campaign_edit"
            >
              Edit
            </Link>
          </td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: AdminStarterCampaignsIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (!this.props.campaigns) {
      return (
        <div>
        </div>
      );
    }
    if (this.props.campaigns.meta) {
      count = this.props.campaigns.meta.count;
    }
    return (
      <div className="campaigns_index">
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            Starter Workflows
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <Link
              to={`/admin/starter_campaigns/new`}
              className="btn btn-primary pull-right new_campaign_btn m-l-10"
            >
              Add a Starter Workflow
            </Link>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                params={this.props.params}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`campaign_name ${this.indicateSorting("name")}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`campaign_category ${this.indicateSorting(
                    "category"
                  )}`}
                  data-sort="category"
                  onClick={this.handleOrder.bind(this)}
                >
                  Category
                </th>
                <th
                  className={`campaign_author ${this.indicateSorting(
                    "author"
                  )}`}
                  data-sort="author"
                  onClick={this.handleOrder.bind(this)}
                >
                  Author
                </th>
                <th className="campaign_description">Description</th>
                <th
                  className={`text-center campaign_status ${this.indicateSorting(
                    "status"
                  )}`}
                  data-sort="status"
                  onClick={this.handleOrder.bind(this)}
                >
                  Status
                </th>
                <th className="text-right campaign_steps">Steps</th>
                <th className="text-right" />
              </tr>
            </thead>
            <tbody>{this.renderCampaigns()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { campaigns: state.campaigns.all };
}

export default connect(
  mapStateToProps,
  { fetchAllStarterCampaigns }
)(AdminStarterCampaignsIndex);
